import { Component, Input } from '@angular/core';

interface Topper {
  imageUrl: string;
  title: string;
  description: string;
}

interface AchievementStat {
  value: string;
  label: string;
}

@Component({
  selector: 'app-achievements',
  templateUrl: './achievements.component.html',
  styleUrls: ['./achievements.component.scss']
})
export class AchievementsComponent {

  @Input() toppers: Topper[] = [];

  stats: AchievementStat[] = [
    {
      value: '100%',
      label: 'Board Exam Pass Rate'
    },
    {
      value: '450+',
      label: 'Distinction Holders'
    },
    {
      value: '35',
      label: 'State Rank Achievers'
    },
    {
      value: '120+',
      label: 'Competitive Exam Selections'
    }
  ];

  highlights = [
    '15 Students secured above 98% in Class X Board Examinations',
    '12 Students achieved above 97% in Class XII Board Examinations',
    'National Level Science Exhibition Winners',
    'State Champions in Inter-School Basketball Tournament'
  ];
}